"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
/* istanbul ignore file */
var IStorageAdapter = /*#__PURE__*/function () {
  function IStorageAdapter() {
    (0, _classCallCheck2["default"])(this, IStorageAdapter);
  }
  return (0, _createClass2["default"])(IStorageAdapter, [{
    key: "getItem",
    value: function getItem() {}
  }, {
    key: "setItem",
    value: function setItem() {}
  }, {
    key: "removeItem",
    value: function removeItem() {}
  }, {
    key: "clear",
    value: function clear() {}
  }, {
    key: "key",
    value: function key() {}
  }]);
}();
module.exports = IStorageAdapter;